export const getLabelMatchesSearch = (
  label: string,
  search: string
): boolean => {
  const splittedSearch = search.toLowerCase().trim().split(' ');
  const words = label.toLowerCase().trim().split(' ');

  return splittedSearch.every((searchWord) =>
    words.some((word) => word.includes(searchWord))
  );
};
